import * as React from 'react';

import { Container, LeftView, BadgeView } from './views/SuggestionView';
import { SearchContext, ISuggestion, ISnowSearchPlacement } from './types';
import { SNOW_SEARCH_SUGGESTION_SELECTED, SNOW_SEARCH_ITEM_SUGGESTION_SELECTED } from './events';
import t from './locales';

interface IProps extends ISuggestion {
  searchContext: SearchContext;
  placement: ISnowSearchPlacement;
}

const Suggestion: React.FC<IProps> = (props) => {
  const { searchContext, placement, type, label, isRecommended } = props;

  function handleClick() {
    const detail = { suggestion: props, placement }
    let clickEvent = null;
    if (searchContext === 'stay') {
      clickEvent = new CustomEvent(SNOW_SEARCH_SUGGESTION_SELECTED, { detail });
    } else {
      clickEvent = new CustomEvent(SNOW_SEARCH_ITEM_SUGGESTION_SELECTED, { detail });
    }
    document.dispatchEvent(clickEvent);
  }

  function iconName(type: string) {
    let name = '';
    switch (type) {
      case 'yado':
        name = 'icon-hotel'; break;
      case 'resort':
        name = 'icon-mountain'; break;
      case 'prefecture':
        name = 'icon-marker_area'; break;
      case 'area':
        name = 'icon-marker_area'; break;
    }
    return name;
  }

  const typeString = t[type] ? t[type]() : '';

  return (
    <Container onClick={handleClick}>
      <LeftView>
        {type && <i className={iconName(type)} />}
        <div className="name">
          <p>{label}</p>
          {isRecommended && <span className="recommended"><span className="fa fa-star" /></span>}
        </div>
      </LeftView>
      <BadgeView>{typeString}</BadgeView>
    </Container>
  );
};

export default Suggestion;
